'use strict'

import css from './tasksite-selection.styles.scss'
import template from './tasksite-selection.template.pug'

class TasksiteSelectionController {
  select() {
    this.selected = true
    this.onSelect({ tasksite: this.tasksite })
  }

  reset() {
    this.selected = false
    this.onSelect({ tasksite: null })
  }
}

export const umsTasksiteSelection = {
  controller: TasksiteSelectionController,
  template: template({ css }),
  bindings: {
    tasksites: '<',
    tasksiteCode: '<?',
    canSelect: '<?',
    onSelect: '&',
  },
}



// WEBPACK FOOTER //
// ./app/orders/components/tasksite-selection/tasksite-selection.component.js